import * as constants from './constants'

export const getReservationsByParam = (referenceNumber, email) => ({
    type: constants.GET_RESERVATIONS_BY_PARAM,
    referenceNumber,
    email,
})

export const getReservationsByParamError = error => ({
    type: constants.GET_RESERVATIONS_BY_PARAM_ERROR,
    error,
})

export const setReservationsByParam = reservations => ({
    type: constants.SET_RESERVATIONS_BY_PARAM,
    reservations,
})

export const clearReservationsByParamErrorState = () => ({
    type: constants.CLEAR_RESERVATIONS_BY_PARAM_ERROR_STATE,
})

export const clearGuestReservationsState = () => ({
    type: constants.CLEAR_RESERVATIONS_BY_PARAM_STATE,
})

export const setGuestReservationsVehicleUpdatedState = () => ({
    type: constants.SET_VEHICLE_UPDATED_STATE,
})

export const clearVehicleUpdatedState = () => ({ type: constants.CLEAR_VEHICLE_UPDATED_STATE })

export const setGuestReservationCancelAmendPolicy = policy => ({
    type: constants.SET_GUEST_RESERVATION_CANCEL_AMEND_POLICY,
    policy,
})

export const updateVehicleError = error => ({
    type: constants.UPDATE_VEHICLE_ERROR,
    error,
})
